import { h } from 'preact'; /** @jsx h */

import './Content.scss';

const Content = ({ width = 'small', type = false, children }) => {
    return <div className={`content content-${width} ${type && type}`}>{children}</div>;
};

export default Content;
